export default function Council2023Entries() {
  return (
    <table id="filetable">
      {/*Start Table*/}
      <tr>
        <th>Meeting Date</th>
        <th>Minutes</th>
        <th>Agenda</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>12-19-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-12-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>12-06-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-12-06-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>12-05-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-12-05-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-21-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-11-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-20-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-11-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-15-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-11-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>11-13-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-11-13-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>10-25-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-10-25-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>10-17-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-10-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>09-19-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-09-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>08-15-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-08-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>07-18-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-07-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>06-20-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-06-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>05-23-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-05-23-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>05-10-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-05-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>04-18-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-04-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>03-21-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-03-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>02-21-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-02-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>01-17-2023</td>
        <td>
          <a href="../docs/council/minutes/2023/2023-01-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
